import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../../components/loader/loader';
import { Box, Paper, Tooltip } from "@mui/material";
import deleteIcon from "../../assets/images/delete.svg";
import editIcon from "../../assets/images/edit.svg";
import { FaRegSquarePlus } from 'react-icons/fa6';
import { deleteTemplate, getTemplateListing, statusUpdateTemplate } from '../../api/context/template';
import CustomisedModal from '../../components/Modal/CustomisedModal';
import { Button, Form, InputGroup } from 'react-bootstrap';
import toast from 'react-hot-toast';
import moment from 'moment';
import { IoCloseSharp } from 'react-icons/io5';

const queueDatatableCustomStyles = {
    headCells: {
        style: {
            display: "flex",
            // justifyContent: "center",
            fontWeight: '600',
            fontSize: '14px',

        },
    },
    cells: {
        style: {
            display: "flex",
            // justifyContent: "center",
            fontSize: '12px',
            fontWeight: '500',
            padding: '12px',
        },
    },

};

const customStyless = {
    control: (provided) => ({
        ...provided,
        border: " 1px solid #EBEBEB",
        padding: '6px',
    }),
};



const TemplateEmail = () => {

    const navigate = useNavigate()

    const [show, setShow] = useState(false);
    const [banner, setBanner] = useState([]);
    const [products, setProducts] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [update, setUpdate] = useState(false);
    const [initial, setInitial] = useState(false);
    const [search, setSearch] = useState("");
    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");
    const [selectedBanner, setSelectedBanner] = useState(null);
    const [showimg, setShowImg] = useState(false);
    const [webimg, setWebImg] = useState([]);
    const [showmobimg, setShowMobImg] = useState(false);
    const [mobimg, setMobImg] = useState([]);
    const [template, setTemplate] = useState([]);
    const [dataCount, setDataCount] = useState();
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(25);
    const itemsPerPage = 8;




    const handleShowWebImage = (promoimage) => {
        setShowImg(true);
        setWebImg(promoimage)
    }

    const handleShowMobImage = (promoimage) => {
        setShowMobImg(true);
        setMobImg(promoimage)
    }

    const handleCloseImage = () => {
        setShowImg(false);
    }

    const handleCloseMobImage = () => {
        setShowMobImg(false);
    }

    const columns = [
        {
            name: "S. No.",
            selector: (row, index) => page == 0 ? index + 1 : (page - 1) * limit + index + 1,
            width: '90px',
            center: true
        },
        {
            id: 'title',
            name: 'Title',
            selector: (row) => row?.template_type,
            cell: (row) => (
                <Tooltip title={row?.template_type} disableInteractive placement='top'>
                    <div className='ellipse_email'>
                        {row?.template_type}
                    </div>
                </Tooltip>
            ),
            grow: 0.8,
            minWidth: '300px',
            reorder: true,
            left: true,
        },
        {
            id: 'createdAt',
            name: 'Created Date',
            selector: (row) => moment(row?.created_date).format('DD/MM/YYYY, hh:mm a'),
            cell: (row) => (
                <Tooltip title={moment(row?.created_date).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement='top'>
                    <div className='ellipse_email'>{moment(row?.created_date).format('DD/MM/YYYY, hh:mm a')}</div>
                </Tooltip>
            ),
            grow: 0.3,
            minWidth: '120px',
            reorder: true,
        },
        // {
        //     id: 'updatedAt',
        //     name: 'Updated Date',
        //     selector: (row) => moment(row?.modified_date).format('DD/MM/YYYY, hh:mm a'),
        //     cell: (row) => (
        //         <Tooltip title={moment(row?.modified_date).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement='top'>
        //             <div className='text-truncate'>{moment(row?.modified_date).format('DD/MM/YYYY, hh:mm a')}</div>
        //         </Tooltip>
        //     ),
        // },
        {
            id: 'createBy',
            name: 'Created by',
            selector: (row) => row?.created_by,
            cell: (row) => <Tooltip title={row?.created_by} disableInteractive placement='top'><div className='ellipse_email'>{row?.created_by}</div></Tooltip>,
            grow: 0.3,
            minWidth: '120px',
            reorder: true,
        },
        {
            name: "Status",
            selector: (row) => row.status,
            cell: (row) => (
                <div className="status_wrap_datatable">
                    <Form.Check
                        role="button"
                        type="switch"
                        id="custom-switch"
                        checked={row.is_active === true}
                        onChange={() => statusActive(row?.id)}
                    />
                </div>
            ),
            grow: 0.1,
            minWidth: '90px',
            reorder: true,
        },

        {
            name: "ACTION",
            cell: (row) =>
                <div>

                    <div className='d-flex flex-row gap-3' role='button'>
                        <Tooltip title="Edit" disableInteractive placement="top">
                            <div className="edit_icon_bg" onClick={() => navigate('/edit-template/' + row.id)}>
                                <img
                                    src={editIcon}
                                    alt="Edit"
                                    className="edit_icon"
                                />
                            </div>
                        </Tooltip>
                        <Tooltip title="Delete" disableInteractive placement="top">
                            <div className="delete_icon_bg" onClick={() => handleConfirm(row?.id)}>
                                <img
                                    src={deleteIcon}
                                    alt="Delete"
                                    className="delete_icon"
                                />
                            </div>
                        </Tooltip>
                    </div>

                </div>,
            grow: 0.1,
            minWidth: '200px',
            reorder: true,
            center:true
        },
    ];


    const fetchTemplateListing = async () => {
        setLoading(true);
        const skip = page != 0 ? (page - 1) * limit : 0;
        getTemplateListing({ skip, limit, search })((response) => {
            if (response?.status_code === 200) {
                setTemplate(response?.data?.results);
                setTotalRows(response?.data?.count);
            } else {
                setTemplate([]);
            }
            setLoading(false);
        });
    };

    const deleteTemplates = (id) => {
        setLoading(true)
        deleteTemplate(id)((response) => {
            if (response?.data?.status_code == 200) {
                setUpdate(!update);
                setModal(!modal);
                setLoading(false);
                toast.success("Template deleted successfully")
            } else {
                setLoading(false);
                toast.error(response?.data?.message);
            }
        });
    };

    const statusActive = (id) => {
        statusUpdateTemplate(id)((response) => {
            if (response?.data?.status_code == 200) {
                setUpdate(!update);
            } else {
            }
        });
    };

    const handleSearchData = (e) => {
        setSearch(e.target.value);
        if (e.target.value == '') {
            setUpdate(!update);
        }
    }

    const handleClearSearch = () => {
        setSearch('');
        setUpdate(!update);
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (search != '') {
                setUpdate(!update)
            }

        }, 800);
        return () => {
            clearTimeout(timeout);
        };
    }, [search]);

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setPage(0);
        setUpdate(!update);
    };

    const handlePageChange = (page) => {
        setPage(page);
        setUpdate(!update);
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    const handleConfirm = (deletingId) => {
        setModal(!modal);
        setDeletingId(deletingId);
    };



    useEffect(() => {
        setLoading(true);
        fetchTemplateListing();

    }, [update]);




    return (
        <>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0">Templates</h4>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="request_wrapper_filter">
                        <div className='dataTable-left'>
                            <InputGroup className="">
                                <Form.Control
                                    placeholder="Search"
                                    aria-label="Search"
                                    aria-describedby="basic-addon2"
                                    value={search}
                                    onChange={handleSearchData}
                                />
                                {search && (
                                    <InputGroup.Text id="basic-addon3" onClick={handleClearSearch} style={{ cursor: "pointer" }}><IoCloseSharp /></InputGroup.Text>
                                )}
                            </InputGroup>
                        </div>
                        <div className='dataTable-right'>
                            <div className="request_btn_wrapper" >
                                <Link className="request_btn" to="/create-template">
                                    <FaRegSquarePlus className="icon" />
                                    Add New
                                </Link>

                            </div>
                        </div>
                    </div>
                    <div className="d_grid_wrapper"></div>
                </div>
                <div className='col-12'>
                    <Box className="products-and-options" sx={{ mt: 1 }}>
                        <Paper square>
                            <div>
                                <DataTable
                                    columns={columns}
                                    data={template}
                                    progressPending={loading}
                                    progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    currentPage={page}
                                    customStyles={queueDatatableCustomStyles}
                                />
                            </div>
                        </Paper>
                    </Box>

                    <CustomisedModal
                        isOpen={modal}
                        customClass={"policy_modal"}
                        toggle={toggleModal}
                    >
                        <h5>Are you sure you want to remove this item?</h5>
                        <div className="policy_Agree">
                            <Button
                                onClick={() => {
                                    setModal(!modal);
                                }}
                                size="lg"
                                className="btn_cancel"
                            >
                                Cancel
                            </Button>
                            <Button
                                size="lg"
                                className="btn"
                                onClick={() => deleteTemplates(deletingId)}
                                disabled={loading}
                            >
                                {loading ? "Loading" : "Delete"}
                            </Button>
                        </div>
                    </CustomisedModal>
                </div>

            </div>
        </>
    )
}

export default TemplateEmail